import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { css } from "@emotion/react";
import { FormattedMessage } from "react-intl";
import { breakpoints } from "style";
import { useAuth } from "hooks";
import { BUTTON_SIZE, PrimaryButton } from "components/Buttons";
import Icon, { ICON_SIZE, ICON_TYPE } from "components/Icon";
import ApplicantInterviewModal from "./ApplicantInterviewModal";

/**
 * ApplicantInterviewInviteButton
 *
 * @param {Object}   application
 * @param {Boolean}  isParentOpen
 */
const ApplicantInterviewInviteButton = ({ application, isParentOpen, ...props }) => {
  const { canScheduleInterviews } = useAuth();
  const [interviewApplicantId, setInterviewApplicantId] = useState(null);
  const showInterview = isParentOpen && !!application?.id && interviewApplicantId === application.id;

  useEffect(() => {
    setInterviewApplicantId(null);
  }, [application?.id, isParentOpen]);

  if (!application?.id || !canScheduleInterviews) return null;

  return (
    <>
      <PrimaryButton
        type="button"
        aria-haspopup="dialog"
        css={styles.inviteButton}
        size={BUTTON_SIZE.small}
        onClick={(event) => {
          event.currentTarget.focus({ preventScroll: true });
          setInterviewApplicantId(application.id);
        }}
        {...props}
      >
        <Icon type={ICON_TYPE.calendar} size={ICON_SIZE.medium} color="inherit" aria-hidden="true" />
        <FormattedMessage id="Missions.Applicants.InterviewModal.Button" />
      </PrimaryButton>
      {showInterview && (
        <ApplicantInterviewModal
          key={application.id}
          application={application}
          show={showInterview}
          onClose={() => setInterviewApplicantId(null)}
        />
      )}
    </>
  );
};

const styles = {
  inviteButton: css`
    white-space: nowrap;

    @media (max-width: ${breakpoints.mobile}) {
      width: 100%;
    }
  `,
};

ApplicantInterviewInviteButton.propTypes = {
  application: PropTypes.object,
  isParentOpen: PropTypes.bool,
};

export default ApplicantInterviewInviteButton;
